



























































import { Component, Prop, Vue } from "vue-property-decorator";
import CzButton from "@/shared/components/cz/CzButton.vue";
import CzCover from "@/shared/components/cz/CzCover.vue";
import CzIcon from "@/shared/components/cz/CzIcon.vue";
import CzTitle from "@/shared/components/cz/CzTitle.vue";
import IconPillButton from "@/shared/components/iconPillButton/iconPillButton.vue";
import IconCart from "@/shared/components/icons/IconCart.vue";
import IconCartOutline from "@/shared/components/icons/IconCartOutline.vue";
import store from "@/shared/core/store";
import { ShopService } from "@/shared/core/services/shopService";
import { Format } from "../../core/helpers/formatHelper";
import { SaleItem } from "../../core/interfaces/saleItem";
import { ModifyMode } from "../../core/constants";

@Component({
  components: { CzButton, CzCover, CzIcon, CzTitle, IconCart, IconCartOutline, IconPillButton },
})
export default class menuShopCart extends Vue {
  @Prop({ type: Boolean, default: false }) controlled!: boolean;

  shop: any = {};
  open: boolean = false;

  get isEmpty() {
    const cart = (this.$store as any).state.cart;
    return !cart || ((cart.sItems || []).length === 0 && (cart.sales || []).length === 0);
  }

  get cartCount() {
    const cart = (this.$store as any).state.cart;
    return cart !== null && cart !== undefined ? cart.count : 0;
  }

  mounted() {
    this.shop = new ShopService();
  }

  increment(sItem: SaleItem) {
    this.shop.modifyUnits(ModifyMode.Increment, sItem, 1);
  }

  decrement(sItem: SaleItem) {
    this.shop.modifyUnits(ModifyMode.Decrement, sItem, 1);
  }

  modify(sItem: SaleItem) {
    const units = Number(sItem.units);
    if (isNaN(units)) {
      return;
    }
    this.shop.modifyUnits(ModifyMode.Exact, sItem, units);
  }

  removeSale(e: any, saleId: any) {
    e.preventDefault();
    this.shop.removeSaleFromCart(saleId);
  }

  getPrice(price: string) {
    return Format.formatCurrency(price);
  }

  getImagePath(img: string) {
    if (img === null || img === undefined || img === "") {
      return store.state.settings.Uploads + "/" + store.state.settings.Mainlogo;
    }
    return store.state.settings.Uploads + "/" + img;
  }

  continueShopping() {
    if (this.controlled) {
      this.open = false;
      return;
    }
    const shopIcon: any = document.getElementById("cartIcon");
    if (shopIcon !== null && shopIcon !== undefined) {
      shopIcon.click();
    }
  }

  // En modo controlado gestionamos la apertura del panel nosotros (sin rdnavbar).
  onCartIconClick() {
    if (this.controlled) {
      this.open = !this.open;
    }
  }

  closeIfControlled() {
    if (this.controlled) {
      this.open = false;
    }
  }
}
